export default __webpack_public_path__ + "static/media/may_long_can.3fec90f1.png";